import { Injectable } from '@angular/core';
import { CmxAuthProfile, SessionService } from "@cemex-core/angular-services-v8";
import { Application } from 'src/cemexcomponents/types/v2';

@Injectable({
  providedIn: 'root'
})
export class StorageManagerService {

  constructor(private sessionService: SessionService) {
   }

   public get access_token(): string {
    return this.sessionService.access_token;
   }

   public get refresh_token(): string {
    return this.sessionService.refresh_token;
   }

   public get expires_in(): string {
    if (!this.sessionService.expiresIn) {
      return '';
    }
    return this.sessionService.expiresIn.toString();
   }

   public get jtw(): string {
    return this.sessionService.jwt;
   }

   public get auth_token(): string {
    return this.sessionService.access_token;
   }

   public get user_profile() {
    return this.sessionService.profile;
   }

   public get user_customer(): any {
    return this.sessionService.customerDetail;
   }

   public get user_applications(): Application[] {
    return this.sessionService.applicationsList;
   }

   public get sessionId(): any {
    return this.sessionService.sessionId;
   }

   public get userInfo(): any {
    return this.sessionService.dataSession;
   }

   public get token_data(): any {
    return this.sessionService.dataSession;
   }

}
